/**
 * @file redirect-change.ts
 * @description Что сделали переадресации при сохранении сущности (phase19.16,
 * партия Р3в, v0.19.64; SB131; контракт r3v-api-contract §3): тексты тостов
 * «Переадресация с /x снята: по адресу снова открывается живая страница» и
 * «Со старого адреса /x — переадресация». Одна функция для публикации
 * страниц, товара, категории, статьи и рубрики.
 */

import type { SiteRedirectChange } from "../api-site-redirects";

export interface RedirectChangeNotes {
  /** Тосты-сведения (созданные правила). */
  info: string[];
  /** Тосты-предупреждения (снятые правила). */
  warning: string[];
}

/** Тексты по ответу сервера; нет изменений — пустые списки. */
export function redirectChangeNotes(change: SiteRedirectChange | null | undefined): RedirectChangeNotes {
  if (!change) return { info: [], warning: [] };
  return {
    info: change.created.map((r) => `Со старого адреса ${r.fromDisplay} теперь переадресация на новый — в течение минуты.`),
    warning: change.removed.map((r) => `Переадресация с ${r.fromDisplay} снята: по адресу снова открывается живая страница.`),
  };
}

/** Показать тосты (вызывающий даёт свой `notify`). */
export function notifyRedirectChange(
  change: SiteRedirectChange | null | undefined,
  notify: { info: (m: string) => void; warning: (m: string) => void },
): void {
  const notes = redirectChangeNotes(change);
  for (const text of notes.info) notify.info(text);
  for (const text of notes.warning) notify.warning(text);
}
